export const TipoTarea = {
	DETALLE_ENVIO: "DETALLE_ENVIO",
	CARGA_DOCUMENTO: "CARGA_DOCUMENTO",
	APROBACION: "APROBACION",
	FLUJO_FIRMA_DETALLE_ENVIO: "FLUJO_FIRMA_DETALLE_ENVIO",
};
